import { render, staticRenderFns } from "./reporteRobotED2.vue?vue&type=template&id=02b734b0&"
import script from "./reporteRobotED2.vue?vue&type=script&lang=js&"
export * from "./reporteRobotED2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports